import script from "./ParsleyMapping.vue?vue&type=script&setup=true&lang=js"
export * from "./ParsleyMapping.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import NeueLoading from "@/components/neue/NeueLoading.vue";
import ParsleyNewItemsTab from "@/components/parsley/ParsleyNewItemsTab.vue";
import ParsleyProductsTab from "@/components/parsley/ParsleyProductsTab.vue";
import ParsleyRunBanner from "@/components/parsley/ParsleyRunBanner.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
script.components = Object.assign({}, { NeueLoading, ParsleyNewItemsTab, ParsleyProductsTab, ParsleyRunBanner, SecondaryNav, SecondaryTop }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { NeueLoading, ParsleyNewItemsTab, ParsleyProductsTab, ParsleyRunBanner, SecondaryNav, SecondaryTop }, script.__o.components);}